import { GenData, QEq } from '@educraft/base';
import { Common, SimpleGenEq, Numerals } from '../genHelper';

export const Percent = {
  divisors: (value: number, divisor: number): number => {
    let count = 0;
    while (value % divisor === 0 && value !== 0) {
      count++;
      value /= divisor;
    }
    return count;
  },

  gen:
    (p2: number, p5: number, percentArray: number[]) =>
    (data: GenData): QEq => {
      const p = percentArray[data.random.next(percentArray.length)];
      const d2a = Math.max(0, 2 - Percent.divisors(p, 2)) + data.random.next(p2);
      const d5a = Math.max(0, 2 - Percent.divisors(p, 5)) + data.random.next(p5);
      const t = 2**d2a * 5**d5a;
      return {
        text: `${p}% z ${t} =`,
        result: (p * t) / 100,
      };
    },

  simple: (percent: number[]) => Percent.gen(2, 2, percent),
  hard: (percent: number[]) => Percent.gen(3, 3, percent),
  harder: (percent: number[]) => Percent.gen(4, 4, percent),
};

export const Round = {
  simple:
    (max: number) =>
    (data: GenData): QEq => {
      const n = data.random.nextDouble() * max;
      const n1 = Math.round(n * 10) / 10;
      return {
        text: n1.toFixed(1).replace('.', ','),
        result: Math.round(n1),
      };
    },

  floor:
    (max: number) =>
    (data: GenData): QEq => {
      const n = data.random.nextDouble() * max;
      const n1 = Math.round(n * 100) / 100;
      return {
        text: n1.toFixed(1).replace('.', ','),
        result: Math.floor(n1),
      };
    },

  ceiling:
    (max: number) =>
    (data: GenData): QEq => {
      const n = data.random.nextDouble() * max;
      const n1 = Math.round(n * 100) / 100;
      return {
        text: n1.toFixed(1).replace('.', ','),
        result: Math.ceil(n1),
      };
    },
};

// Log
export class Math_Log__2__To6 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `log${Numerals.subScript(2)} ${2**n} =`, result: n }),
        0,
        6
      ),
      'Math_Log__2__To6'
    );
  }
}
export class Math_Log__2__To9 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `log${Numerals.subScript(2)} ${2**n} =`, result: n }),
        0,
        9
      ),
      'Math_Log__2__To9'
    );
  }
}
export class Math_Log__2__To10 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `log${Numerals.subScript(2)} ${2**n} =`, result: n }),
        0,
        10
      ),
      'Math_Log__2__To10'
    );
  }
}
export class Math_Log__2__To16 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `log${Numerals.subScript(2)} ${2**n} =`, result: n }),
        0,
        16
      ),
      'Math_Log__2__To16'
    );
  }
}
export class Math_Log__2__To20 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `log${Numerals.subScript(2)} ${2**n} =`, result: n }),
        0,
        20
      ),
      'Math_Log__2__To20'
    );
  }
}
export class Math_Log__10__To6 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `log${Numerals.subScript(10)} ${10**n} =`, result: n }),
        0,
        6
      ),
      'Math_Log__10__To6'
    );
  }
}
export class Math_Log__10__To9 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `log${Numerals.subScript(10)} ${10**n} =`, result: n }),
        0,
        9
      ),
      'Math_Log__10__To9'
    );
  }
}

// Power
export class Math_Power__2X__To5 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `2${Numerals.superScript(n)} =`, result: 1 << n }), 0, 5),
      'Math_Power__2X__To5'
    );
  }
}
export class Math_Power__2X__To10 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `2${Numerals.superScript(n)} =`, result: 1 << n }), 0, 10),
      'Math_Power__2X__To10'
    );
  }
}
export class Math_Power__2X__To16 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `2${Numerals.superScript(n)} =`, result: 1 << n }), 0, 16),
      'Math_Power__2X__To16'
    );
  }
}
export class Math_Power__2X__To20 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `2${Numerals.superScript(n)} =`, result: 1 << n }), 0, 20),
      'Math_Power__2X__To20'
    );
  }
}
export class Math_Power__X2__To5 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `${n}${Numerals.superScript(2)} =`, result: n * n }), 0, 5),
      'Math_Power__X2__To5'
    );
  }
}
export class Math_Power__X2__To10 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `${n}${Numerals.superScript(2)} =`, result: n * n }), 0, 10),
      'Math_Power__X2__To10'
    );
  }
}
export class Math_Power__X2__To16 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `${n}${Numerals.superScript(2)} =`, result: n * n }), 0, 16),
      'Math_Power__X2__To16'
    );
  }
}
export class Math_Power__X2__To20 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `${n}${Numerals.superScript(2)} =`, result: n * n }), 0, 20),
      'Math_Power__X2__To20'
    );
  }
}
export class Math_Power__X3__To5 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `${n}${Numerals.superScript(3)} =`, result: n * n * n }), 0, 5),
      'Math_Power__X3__To5'
    );
  }
}
export class Math_Power__X3__To10 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `${n}${Numerals.superScript(3)} =`, result: n * n * n }),
        0,
        10
      ),
      'Math_Power__X3__To10'
    );
  }
}
export class Math_Power__X3__To20 extends SimpleGenEq {
  constructor() {
    super(
      Common.string(
        (n) => ({ text: `${n}${Numerals.superScript(3)} =`, result: n * n * n }),
        0,
        20
      ),
      'Math_Power__X3__To20'
    );
  }
}

// SquareRoot
export class Math_SquareRoot__To5 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `\u221a${n * n} =`, result: n }), 0, 5),
      'Math_SquareRoot__To5'
    );
  }
}
export class Math_SquareRoot__To10 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `\u221a${n * n} =`, result: n }), 0, 10),
      'Math_SquareRoot__To10'
    );
  }
}
export class Math_SquareRoot__To16 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `\u221a${n * n} =`, result: n }), 0, 16),
      'Math_SquareRoot__To16'
    );
  }
}
export class Math_SquareRoot__To20 extends SimpleGenEq {
  constructor() {
    super(
      Common.string((n) => ({ text: `\u221a${n * n} =`, result: n }), 0, 20),
      'Math_SquareRoot__To20'
    );
  }
}

// Percent
const p10_90 = [10, 20, 30, 40, 50, 60, 70, 80, 90];
const p1_120 = [
  1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
  95, 100, 110, 120,
];
const p1_500 = [...p1_120, 150, 200, 250, 300, 400, 500];

export class Math_Percent__To10_Po10__Base extends SimpleGenEq {
  constructor() {
    super(Percent.simple(p10_90), 'Math_Percent__To10_Po10__Base');
  }
}
export class Math_Percent__To10_Po10__Harder extends SimpleGenEq {
  constructor() {
    super(Percent.hard(p10_90), 'Math_Percent__To10_Po10__Harder');
  }
}
export class Math_Percent__To10_Po10__Hardest extends SimpleGenEq {
  constructor() {
    super(Percent.harder(p10_90), 'Math_Percent__To10_Po10__Hardest');
  }
}
export class Math_Percent__To120__Base extends SimpleGenEq {
  constructor() {
    super(Percent.simple(p1_120), 'Math_Percent__To120__Base');
  }
}
export class Math_Percent__To120__Harder extends SimpleGenEq {
  constructor() {
    super(Percent.hard(p1_120), 'Math_Percent__To120__Harder');
  }
}
export class Math_Percent__To120__Hardest extends SimpleGenEq {
  constructor() {
    super(Percent.harder(p1_120), 'Math_Percent__To120__Hardest');
  }
}
export class Math_Percent__To500_Base extends SimpleGenEq {
  constructor() {
    super(Percent.simple(p1_500), 'Math_Percent__To500_Base');
  }
}
export class Math_Percent__To500__Harder extends SimpleGenEq {
  constructor() {
    super(Percent.hard(p1_500), 'Math_Percent__To500__Harder');
  }
}
export class Math_Percent__To500__Hardest extends SimpleGenEq {
  constructor() {
    super(Percent.harder(p1_500), 'Math_Percent__To500__Hardest');
  }
}

// Rounding
export class Math_Rounding__WholeNumber extends SimpleGenEq {
  constructor() {
    super(Round.simple(10), 'Math_Rounding__WholeNumber');
  }
}
export class Math_Rounding__Down extends SimpleGenEq {
  constructor() {
    super(Round.floor(10), 'Math_Rounding__Down');
  }
}
export class Math_Rounding__Up extends SimpleGenEq {
  constructor() {
    super(Round.ceiling(10), 'Math_Rounding__Up');
  }
}
